import React, { Fragment } from 'react';

import { Accent, Box, Stack, Text, Title } from '@nerdwallet/currency';

import { Article } from '~/generated-graphql/generated-types';
import { trackInteraction } from '~/client/lib/analytics-helpers';
import { HOMEPAGE as analyticsBase } from '~/client/lib/analytics-constants';
import NewsArticlesAuthor from '../news-articles-author/news-articles-author';
import styles from './news-articles-sidebar.module.less';

type NewsArticlesSidebarProps = {
  articles: Array<Article>;
};

const NewsArticlesSidebar = ({
  articles,
}: NewsArticlesSidebarProps): JSX.Element => (
  <Fragment>
    <Box className={styles.accentWrapper} marginBottom="3">
      <Accent>Latest Financial News</Accent>
    </Box>
    <Stack dividers={1} spacing={0}>
      {articles.map((article: Article, i: number) => (
        <Box
          borderColor="neutral-dark"
          borderTop={i === 0 ? 1 : 0}
          className={styles.articleRow}
          key={article.id}
          paddingBottom="3-half"
          paddingTop="3"
        >
          <Title className={styles.articleNumber}>{i + 1}</Title>
          <Box>
            <a
              className={styles.articleLink}
              href={article.link}
              onClick={() =>
                trackInteraction({
                  entityName: `breaking_news_feed_sidebar_${article.id}`,
                  sectionName: analyticsBase.section_name,
                  action: 'select',
                })
              }
            >
              <Text bold>{article.title}</Text>
            </a>
            <Box marginTop="2">
              <NewsArticlesAuthor
                avatarUrl={article?.authors?.[0]?.avatarUrls?.[0]?.url}
                authorUrl={article?.authors?.[0]?.link}
                name={article?.authors?.[0]?.name ?? 'NerdWallet'}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Stack>
  </Fragment>
);

NewsArticlesSidebar.displayName = 'NewsArticlesSidebar';

export default NewsArticlesSidebar;
